import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/*
 * The one column every channel tab reads in: centred in the pane, 4xl wide,
 * inside the same padding and scroll gutter, so switching between Overview,
 * Data, Feed and Files never moves the content on a wide screen.
 */
export const CHANNEL_TAB_SCROLL_CLASS =
  "h-full min-h-0 overflow-x-hidden overflow-y-auto overscroll-none scrollbar-thin [scrollbar-gutter:stable_both-edges]";
/** The column's horizontal frame alone, for a bar that sits outside the scrolling area. */
export const CHANNEL_TAB_FRAME_CLASS = "mx-auto w-full max-w-[1280px] px-4 sm:px-6";
export const CHANNEL_TAB_COLUMN_CLASS = "mx-auto w-full max-w-4xl";

export function ChannelTabColumn({
  children,
  className,
  scrollClassName,
  fill = false,
}: {
  children: ReactNode;
  /** Layout of the column's own content. */
  className?: string;
  /** Extra classes for the scrolling area, such as a container query root. */
  scrollClassName?: string;
  /** The frame takes the pane's full height, for content that places itself within it. */
  fill?: boolean;
}) {
  return (
    <div className={cn(CHANNEL_TAB_SCROLL_CLASS, scrollClassName)}>
      <div className={cn(CHANNEL_TAB_FRAME_CLASS, "py-4 sm:py-5", fill && "h-full")}>
        <div className={cn(CHANNEL_TAB_COLUMN_CLASS, className)}>{children}</div>
      </div>
    </div>
  );
}
